import {ActionList, ActionMenu, Button} from '@primer/react'
import {SortAscIcon, SortDescIcon, TriangleDownIcon} from '@primer/octicons-react'
import type {SortDirection} from '../../utils/filter-utils'

export function SortFilter({
  sortDirection,
  onSortChange,
  className,
  nested,
}: {
  sortDirection: SortDirection
  onSortChange: (direction: SortDirection) => void
  className?: string
  nested?: boolean
}) {
  const label = sortDirection === 'newest' ? 'Newest' : 'Oldest'
  const icon = sortDirection === 'newest' ? SortDescIcon : SortAscIcon

  if (nested) {
    return (
      // aria-labelledby="" overrides ActionList's built-in ariaLabelledBy so this
      // nested list doesn't inherit the overflow menu's "More actions" label.
      <ActionList selectionVariant="single" aria-labelledby="" aria-label="Order">
        <ActionList.Group>
          <ActionList.GroupHeading>Order</ActionList.GroupHeading>
          <ActionList.Item selected={sortDirection === 'newest'} onSelect={() => onSortChange('newest')}>
            <ActionList.LeadingVisual>
              <SortDescIcon />
            </ActionList.LeadingVisual>
            Newest
          </ActionList.Item>
          <ActionList.Item selected={sortDirection === 'oldest'} onSelect={() => onSortChange('oldest')}>
            <ActionList.LeadingVisual>
              <SortAscIcon />
            </ActionList.LeadingVisual>
            Oldest
          </ActionList.Item>
        </ActionList.Group>
      </ActionList>
    )
  }

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <Button
          variant="invisible"
          leadingVisual={icon}
          trailingAction={TriangleDownIcon}
          className={className}
          data-testid="sort-filter-button"
        >
          {label}
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay width="auto">
        <ActionList selectionVariant="single">
          <ActionList.Item selected={sortDirection === 'newest'} onSelect={() => onSortChange('newest')}>
            <ActionList.LeadingVisual>
              <SortDescIcon />
            </ActionList.LeadingVisual>
            Newest
          </ActionList.Item>
          <ActionList.Item selected={sortDirection === 'oldest'} onSelect={() => onSortChange('oldest')}>
            <ActionList.LeadingVisual>
              <SortAscIcon />
            </ActionList.LeadingVisual>
            Oldest
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
